<script lang="ts">
	import { getOverAllChartsConfig } from 'src/components/Chart/chart_config';
	import ConsumptionOverallChart from 'src/components/Consumption/ConsumptionOverallChart.svelte';
	import { isPremiumUser } from 'src/helpers/user_helpers';
	import ChartControls from 'src/components/Chart/ChartControls.svelte';
	import type { chartControlsDataInterface } from 'src/components/Chart/chart_control_helpers';
	import { getUserTimeZoneDate } from 'src/helpers/date_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';
	import { edit } from 'src/stores/ui/edit_lists';

	let chartControlsData: chartControlsDataInterface;
	let chartControlsElement: ChartControls;

	const chartControlsEvent = (e: CustomEvent) => {
			chartControlsData = e.detail;
		},
		onChangeEvent = (e: CustomEvent) => {
			if (e.detail.action == 'dblClick') {
				chartControlsElement.changeDateRangeOnClick(e);
			}
		},
		chartConfig = getOverAllChartsConfig('bar');

	const enabledHourControl = isPremiumUser();
</script>

<!-- //A fixed height is applied to prevent drag-and-drop jumping and does not affect widget behavior on mobile or desktop. -->
<div
	class="cursor-pointer"
	style={`overflow: hidden;${$edit ? 'height:180px' : ''}`}
	role="presentation"
	on:click
>
	<ChartControls
		bind:this={chartControlsElement}
		chartControlID="chart-overall-range-dp"
		overallPage={true}
		showFormControls={false}
		{enabledHourControl}
		timeZone={getUserTimeZoneDate()}
		on:init={chartControlsEvent}
		on:change={chartControlsEvent}
	/>

	{#if chartControlsData}
		<ConsumptionOverallChart
			dashWidget={true}
			{chartConfig}
			{chartControlsData}
			reqURL={chartConfig.url}
			title={capFirstChar(
				$format('text_total_energy', {
					default: 'Total Energy',
				}),
			)}
			hideTooltip={$edit}
			on:change={onChangeEvent}
		/>
	{/if}
</div>
